<h1 mat-dialog-title>Importing {{ importType }}...</h1>
<mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
